import { useEffect, useState } from "react";
import Button from "../../Buttons/button";
import {
  createFeedbackRequest,
  getUsageReportRequest,
  selectPersonalDashboard,
} from "../../../redux/slices/personalDashboardSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import negativeIcon from "./../../../assets/images/negative.png";
import negativeHoverIcon from "./../../../assets/images/nagative_hover.png";
import neutralIcon from "./../../../assets/images/neutral.png";
import neutralHoverIcon from "./../../../assets/images/neutral_hover.png";
import smileyIcon from "./../../../assets/images/smiley.png";
import smileyHoverIcon from "./../../../assets/images/smiley_hover.png";

export default function GiveFeedbackModel({ setstate, setPopup, id }) {
  const state = useSelector(selectPersonalDashboard);
  const dispatch = useDispatch();

  // Dispatch when id changes
  useEffect(() => {
    if (id) {
      dispatch(getUsageReportRequest(id.id));
    }
  }, [dispatch, id]);

  // Dispatch when usageReportData is empty
  useEffect(() => {
    if (Object.keys(state?.usageReportData).length === 0) {
      dispatch(getUsageReportRequest(id.id));
    }
  }, [dispatch, id, state?.usageReportData]);

  const [Words, setWords] = useState("");
  const [svgs, setSvgs] = useState({
    good: false,
    normal: false,
    bad: false,
  });

  const handleFeedbackType = () => {
    if (svgs.good) return "positive";
    if (svgs.normal) return "general";
    if (svgs.bad) return "negative";
    return null;
  };

  const [feedbackType, setFeedbackType] = useState(null);
  const handleSendFeedback = () => {
    const feedbackType = handleFeedbackType();
    if (feedbackType) {
      setFeedbackType(feedbackType);
    }
  };

  useEffect(() => {
    if (
      feedbackType &&
      state.usageReportData?.user?.id &&
      state.usageReportData?.service?.id
    ) {
      dispatch(
        createFeedbackRequest({
          user_id: state.usageReportData?.user?.id,
          service_id: state.usageReportData?.service?.id,
          rating: feedbackType,
          feedback_details: Words,
        })
      );
      setFeedbackType(null); // Reset feedbackType after dispatching.
    }
  }, [dispatch, state.usageReportData, feedbackType, Words]);

  return (
    <div className="transform rounded-[12px] lg:rounded-[24px] bg-[#363D50] transition-all lg:w-[920px] flex">
      <div className="bg-[#242B3E] rounded-l-[24px] w-[320px] p-[32px] hidden lg:block">
        <div className="flex flex-col gap-[24px] w-[256px] h-[456px] justify-center items-center">
          <div className="p-[10px] bg-[#363D50] rounded-[16px]">
            <svg
              width="56"
              height="56"
              viewBox="0 0 56 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.1766 16.0463C17.6053 15.158 19.348 14.9298 20.9573 15.4203L32.6939 18.9973C34.3033 19.4878 35.096 21.2983 34.3648 22.8136C33.796 23.9926 32.4733 24.6054 31.2061 24.2771L25.3166 22.7514C25.1979 22.7194 25.0781 22.7069 24.9606 22.7123C24.607 22.7283 24.2793 22.9057 24.0719 23.189C23.9958 23.293 23.9359 23.4113 23.8968 23.5411C23.8576 23.6708 23.8421 23.8025 23.848 23.9312C23.8693 24.4033 24.1783 24.8291 24.6429 24.9843L29.3335 26.6045C30.8947 27.1438 32.5828 27.1969 34.1749 26.757L46.7216 23.29C47.6027 23.0465 48.5423 23.3761 49.0782 24.1165C49.7982 25.1112 49.5594 26.5034 48.5491 27.2014L33.7967 37.3927C32.3755 38.3744 30.5923 38.6759 28.9274 38.2158L16.1067 34.6731C15.3983 34.4773 14.6666 34.3781 13.9316 34.3781H8.1257C7.48137 34.3781 6.95904 34.9004 6.95904 35.5448C6.95904 36.1891 7.48137 36.7114 8.1257 36.7114H13.9316C14.4566 36.7114 14.9792 36.7823 15.4853 36.9222L28.3059 40.4649C30.6368 41.109 33.1333 40.6869 35.1229 39.3125L49.8753 29.1211C51.9623 27.6794 52.4557 24.8033 50.9684 22.7485C49.8613 21.2188 47.9203 20.538 46.1002 21.0409L36.5326 23.6847C37.7693 20.9106 36.3021 17.6577 33.3741 16.7653L21.6375 13.1883C19.3845 12.5016 16.9448 12.8211 14.9446 14.0647L6.38382 19.3873C5.83663 19.7275 5.66884 20.4469 6.00905 20.9941C6.34927 21.5413 7.06865 21.7091 7.61584 21.3689L16.1766 16.0463Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="flex flex-col gap-[4px]">
            <span className="text-primary">Give Service Feedback</span>
            <span className="text-secondary">
              Let your company know about how this service has been working for
              you. Positive, general, and especially negative!
            </span>
          </div>
        </div>
      </div>
      <div className="flex md:w-[600px] pt-[16px] pr-[12px] md:pr-[24px] pb-[12px] md:pb-[24px] pl-[12px] md:pl-[24px]">
        <div className="flex flex-col w-full">
          <div className="flex h-auto md:h-[40px] justify-between items-center mb-3 md:mb-6">
            <div className="flex w-[auto] h-auto md:h-[40px] justify-center items-center gap-[10px] md:gap-[16px]">
              <Link to={`/personal_dashboard/services/usage_report/${id.id}`}>
                <img
                  className="w-[40px] h-[40px] rounded-lg"
                  src={state.usageReportData?.service?.image_url}
                  alt="service-img"
                />
              </Link>
              <div className="flex flex-col justify-start items-start">
                <span className="text-primary text-left">
                  {state.usageReportData?.service?.name}
                </span>
                <span className="text-secondary">
                  {state.usageReportData?.service?.category_name}
                </span>
              </div>
            </div>

            <svg
              className="cursor-pointer"
              onClick={() => {
                setPopup(false);
              }}
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.4099 12.0002L17.7099 7.71019C17.8982 7.52188 18.004 7.26649 18.004 7.00019C18.004 6.73388 17.8982 6.47849 17.7099 6.29019C17.5216 6.10188 17.2662 5.99609 16.9999 5.99609C16.7336 5.99609 16.4782 6.10188 16.2899 6.29019L11.9999 10.5902L7.70994 6.29019C7.52164 6.10188 7.26624 5.99609 6.99994 5.99609C6.73364 5.99609 6.47824 6.10188 6.28994 6.29019C6.10164 6.47849 5.99585 6.73388 5.99585 7.00019C5.99585 7.26649 6.10164 7.52188 6.28994 7.71019L10.5899 12.0002L6.28994 16.2902C6.19621 16.3831 6.12182 16.4937 6.07105 16.6156C6.02028 16.7375 5.99414 16.8682 5.99414 17.0002C5.99414 17.1322 6.02028 17.2629 6.07105 17.3848C6.12182 17.5066 6.19621 17.6172 6.28994 17.7102C6.3829 17.8039 6.4935 17.8783 6.61536 17.9291C6.73722 17.9798 6.86793 18.006 6.99994 18.006C7.13195 18.006 7.26266 17.9798 7.38452 17.9291C7.50638 17.8783 7.61698 17.8039 7.70994 17.7102L11.9999 13.4102L16.2899 17.7102C16.3829 17.8039 16.4935 17.8783 16.6154 17.9291C16.7372 17.9798 16.8679 18.006 16.9999 18.006C17.132 18.006 17.2627 17.9798 17.3845 17.9291C17.5064 17.8783 17.617 17.8039 17.7099 17.7102C17.8037 17.6172 17.8781 17.5066 17.9288 17.3848C17.9796 17.2629 18.0057 17.1322 18.0057 17.0002C18.0057 16.8682 17.9796 16.7375 17.9288 16.6156C17.8781 16.4937 17.8037 16.3831 17.7099 16.2902L13.4099 12.0002Z"
                fill="white"
              />
            </svg>
          </div>

          <div className="flex flex-col gap-[12px] md:gap-[24px] pb-[12px] md:pb-[24px]">
            <div className="flex flex-col gap-[4px]">
              <span className="text-primary text-left !text-[16px] !leading-[22px] md:!text-[18px] md:!leading-[36px]">
                Tell us anything you have to say about this service!
              </span>
            </div>
            <div className="flex flex-col p-[2px] border-[1px] border-[#596073] rounded-[16px] ">
              <textarea
                className="!h-[180px] w-full placeholder:text-[#A5AEBC] resize-none border-none focus:ring-0 rounded-[12px] bg-[#363D50]"
                onChange={(e) => {
                  setWords(e.target.value);
                }}
                placeholder={"This service would better suite me if..."}
              />
              <div className="flex justify-between items-center pt-[17px] pb-[7px] px-[10px]">
                <span className="text-secondary text-left">
                  {Words?.length}/500
                </span>
                {/* <div className="flex items-center gap-[4px] w-[91px] h-[36px] hover:cursor-pointer hidden">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.9733 9.52679C12.8478 9.40126 12.6775 9.33073 12.5 9.33073C12.3225 9.33073 12.1522 9.40126 12.0267 9.52679C11.9011 9.65233 11.8306 9.82259 11.8306 10.0001C11.8306 10.1777 11.9011 10.3479 12.0267 10.4735L12.22 10.6668H11.1667C10.4594 10.6668 9.78115 10.3858 9.28105 9.88574C8.78095 9.38565 8.5 8.70737 8.5 8.00012C8.5 7.29288 8.78095 6.6146 9.28105 6.11451C9.78115 5.61441 10.4594 5.33346 11.1667 5.33346H12.2267L12.0267 5.52679C11.9642 5.58877 11.9146 5.6625 11.8807 5.74374C11.8469 5.82498 11.8295 5.91212 11.8295 6.00012C11.8295 6.08813 11.8469 6.17527 11.8807 6.25651C11.9146 6.33775 11.9642 6.41148 12.0267 6.47346C12.089 6.53525 12.1628 6.58413 12.2441 6.6173C12.3253 6.65048 12.4123 6.6673 12.5 6.66679C12.5877 6.6673 12.6747 6.65048 12.7559 6.6173C12.8372 6.58413 12.911 6.53525 12.9733 6.47346L14.3067 5.14012C14.3685 5.07783 14.4173 5.00395 14.4505 4.92273C14.4837 4.8415 14.5005 4.75453 14.5 4.66679C14.5005 4.57905 14.4837 4.49208 14.4505 4.41085C14.4173 4.32963 14.3685 4.25575 14.3067 4.19346L12.9733 2.86012C12.9112 2.79796 12.8374 2.74866 12.7562 2.71502C12.675 2.68138 12.5879 2.66406 12.5 2.66406C12.3225 2.66406 12.1522 2.73459 12.0267 2.86012C11.9011 2.98566 11.8306 3.15592 11.8306 3.33346C11.8306 3.51099 11.9011 3.68125 12.0267 3.80679L12.22 4.00012H11.1667C10.5062 4.00061 9.8561 4.16463 9.27445 4.47756C8.69281 4.79049 8.1977 5.24257 7.83333 5.79346C7.46897 5.24257 6.97386 4.79049 6.39221 4.47756C5.81057 4.16463 5.16048 4.00061 4.5 4.00012H3.16667C2.98986 4.00012 2.82029 4.07036 2.69526 4.19539C2.57024 4.32041 2.5 4.48998 2.5 4.66679C2.5 4.8436 2.57024 5.01317 2.69526 5.1382C2.82029 5.26322 2.98986 5.33346 3.16667 5.33346H4.5C5.20724 5.33346 5.88552 5.61441 6.38562 6.11451C6.88572 6.6146 7.16667 7.29288 7.16667 8.00012C7.16667 8.70737 6.88572 9.38565 6.38562 9.88574C5.88552 10.3858 5.20724 10.6668 4.5 10.6668H3.16667C2.98986 10.6668 2.82029 10.737 2.69526 10.8621C2.57024 10.9871 2.5 11.1566 2.5 11.3335C2.5 11.5103 2.57024 11.6798 2.69526 11.8049C2.82029 11.9299 2.98986 12.0001 3.16667 12.0001H4.5C5.16048 11.9996 5.81057 11.8356 6.39221 11.5227C6.97386 11.2098 7.46897 10.7577 7.83333 10.2068C8.1977 10.7577 8.69281 11.2098 9.27445 11.5227C9.8561 11.8356 10.5062 11.9996 11.1667 12.0001H12.2267L12.0267 12.1935C11.9642 12.2554 11.9146 12.3292 11.8807 12.4104C11.8469 12.4916 11.8295 12.5788 11.8295 12.6668C11.8295 12.7548 11.8469 12.8419 11.8807 12.9232C11.9146 13.0044 11.9642 13.0781 12.0267 13.1401C12.089 13.2019 12.1628 13.2508 12.2441 13.284C12.3253 13.3171 12.4123 13.334 12.5 13.3335C12.5877 13.334 12.6747 13.3171 12.7559 13.284C12.8372 13.2508 12.911 13.2019 12.9733 13.1401L14.3067 11.8068C14.3685 11.7445 14.4173 11.6706 14.4505 11.5894C14.4837 11.5082 14.5005 11.4212 14.5 11.3335C14.5005 11.2457 14.4837 11.1587 14.4505 11.0775C14.4173 10.9963 14.3685 10.9224 14.3067 10.8601L12.9733 9.52679Z"
                      fill="#FFD74A"
                    />
                  </svg>
                  <span className="text-secondary underline !text-[#FFD74A] !text-[14px] !leading-[24px] !font-normal">
                    topic idea
                  </span>
                </div> */}
              </div>
              <div className="px-[10px] flex flex-col">
                <div className="h-[1px] bg-[#596073]" />
                <div className="flex flex-col gap-[4px] py-[11px] md:gap-[0px] md:flex-row md:justify-between items-center">
                  <span className="text-primary !text-[14px]">
                    Select feedback type
                  </span>
                  <div className="flex gap-[8px]">
                    <div
                      onClick={() => {
                        setSvgs({
                          ...svgs,
                          good: !svgs.good,
                          normal: false,
                          bad: false,
                        });
                      }}
                      className={`${
                        svgs.good
                          ? "active good rating_wrapper cursor-pointer"
                          : "false good rating_wrapper cursor-pointer"
                      }`}
                    >
                      <img
                        src={smileyIcon}
                        alt="rating-img"
                        className="rating_icon inactive"
                      />
                      <img
                        src={smileyHoverIcon}
                        alt="rating-img"
                        className="rating_icon active"
                      />
                    </div>
                    <div
                      onClick={() => {
                        setSvgs({
                          ...svgs,
                          good: false,
                          normal: !svgs.normal,
                          bad: false,
                        });
                      }}
                      className={`${
                        svgs.normal
                          ? "active average rating_wrapper cursor-pointer"
                          : "false average rating_wrapper cursor-pointer"
                      }`}
                    >
                      <img
                        src={neutralIcon}
                        alt="rating-img"
                        className="rating_icon inactive"
                      />
                      <img
                        src={neutralHoverIcon}
                        alt="rating-img"
                        className="rating_icon active"
                      />
                    </div>
                    <div
                      onClick={() => {
                        setSvgs({
                          ...svgs,
                          good: false,
                          normal: false,
                          bad: !svgs.bad,
                        });
                      }}
                      className={`${
                        svgs.bad
                          ? "active bad rating_wrapper cursor-pointer"
                          : "false bad rating_wrapper cursor-pointer"
                      }`}
                    >
                      <img
                        src={negativeIcon}
                        alt="rating-img"
                        className="rating_icon inactive"
                      />
                      <img
                        src={negativeHoverIcon}
                        alt="rating-img"
                        className="rating_icon active"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end items-center md:w-[100%] md:h-[53px] gap-[12px]">
            <Button
              onClick={() => {
                setPopup(false);
                handleSendFeedback();
              }}
              fill={true}
              position={"center"}
            >
              Submit Feedback
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
